import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';
import {HitOnlineEnums} from '@/../../app/src/helpers/constants';
import {translate} from '../../plugins/i18n/i18n';

export default class Config extends BaseModel {
  constructor({
    id,
    label = undefined,
    name = undefined,
    visible = undefined,
    customisable = undefined,
    datatype = undefined,
    value = undefined,
    global = undefined,
  }) {
    super(id, undefined, name);
    this.label = label;
    this.name = name;
    this.visible = visible;
    this.customisable = customisable;
    this.datatype = datatype
      ? HitOnlineEnums.getEnumValue('CONFIG_DATATYPE', datatype, translate)
      : null;
    this.value = value;
    this.global = global;
  }

  static get orderKey() {
    return 'name';
  }

  static get apiRoute() {
    return 'config';
  }

  static get fkName() {
    return 'name';
  }

  static get joinAttrsKey() {
    return ['name'];
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(['name']);
  }

  static get detailAttrs() {
    return this.getAttributes([
      'id',
      'label',
      'name',
      'value',
      'visible',
      'customisable',
      'datatype',
      'global',
      'created_date',
      'modification_date',
    ]);
  }

  static get advancedConfigAttrs() {
    return this.getAttributes(
      ['label', 'name', 'datatype', 'personalValue', 'companyValue'],
      ['userId', 'value', 'customisable'],
    );
  }

  get fkName() {
    return this.name;
  }

  static get allAttributes() {
    return [
      new AT.StringAttribute({
        name: 'id',
        tableProperties: {
          header: 'hit-app.common.id',
          maxWidth: '1fr',
        },
      }),
      new AT.StringAttribute({
        name: 'label',
        tableProperties: {
          header: 'hit-app.configuration.configuration',
          maxWidth: '1fr',
        },
      }),
      new AT.StringAttribute({
        name: 'name',
        tableProperties: {
          header: 'hit-app.configuration.name',
          maxWidth: '1fr',
        },
      }),
      new AT.StringAttribute({
        name: 'userId',
        column: 'user_id',
        tableProperties: {
          header: 'hit-app.common.user-id',
          maxWidth: '1fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'visible',
        tableProperties: {
          header: 'hit-app.common.visible',
        },
      }),
      new AT.BooleanAttribute({
        name: 'customisable',
        tableProperties: {
          header: 'hit-app.common.customisable',
        },
      }),
      new AT.EnumerationAttribute({
        name: 'datatype',
        enumType: 'CONFIG_DATATYPE',
        enumClass: HitOnlineEnums,
        tableProperties: {
          header: 'hit-app.configuration.datatype',
        },
      }),
      new AT.StringAttribute({
        name: 'value',
        tableProperties: {
          header: 'hit-app.common.value',
        },
      }),
      new AT.NotFetchedAttribute({
        name: 'personalValue',
        tableProperties: {
          header: 'hit-app.configuration.value',
        },
      }),
      new AT.NotFetchedAttribute({
        name: 'companyValue',
        tableProperties: {
          header: 'hit-app.configuration.company-value',
        },
      }),
      new AT.BooleanAttribute({
        name: 'global',
        tableProperties: {
          header: 'hit-app.common.global',
        },
      }),
    ];
  }
}
